import React from "react";
import { Grid, Divider, Chip } from "@mui/material";
import SoftBox from "components/SoftComponents/SoftBox";
import SoftTypography from "components/SoftComponents/SoftTypography";
import SoftInput from "components/SoftComponents/SoftInput";

// Helper to render error text
const ErrorMessage = ({ error }) => {
  if (!error) return null;
  return (
    <SoftTypography variant="caption" color="error" fontWeight="medium" sx={{ display: 'block', mt: 0.5 }}>
      {error.message}
    </SoftTypography>
  );
};

const YarraTramsForm = ({ register, errors, watch, setValue, preview = false, data = null, campaignType = null }) => {
  // If in preview mode, we use the passed 'data' prop; otherwise, we watch the form state
  const currentValues = preview ? data : watch("formData");
  const selectedType = currentValues?.type || campaignType?.campaign_type || "general";
  // console.log('selectedType: ', selectedType)

  // const typeOptions = [
  //   { value: "disruption", label: "Disruption", desc: "Service Disruption" },
  //   { value: "planned", label: "Planned", desc: "Planned Notice" },
  //   { value: "service", label: "Service", desc: "Service Alert" },
  // ];

  // Helper to find the label for the preview chip
  // const activeOption = typeOptions.find(opt => opt.value === selectedType);

  return (
    <SoftBox 
      p={preview ? 1.5 : 2} 
      sx={{ 
        border: preview ? '1px solid #ddd' : '1px dashed #ccc', 
        borderRadius: '8px', 
        backgroundColor: '#fff',
        height: preview ? '280px' : 'auto',
        overflowY: preview ? 'auto' : 'visible'
      }}
    >
      {/* {!preview && (
        <>
          <SoftBox mb={3}>
            <SoftBox pl={1} mb={1}>
              <SoftTypography variant="body3" fontWeight="bold">Form Style</SoftTypography>
            </SoftBox>
            <Grid container spacing={2}>
              {typeOptions.map((opt) => (
                <Grid item xxs={12} sm={4} key={opt.value}>
                  <SoftBox
                    onClick={() => setValue("formData.type", opt.value, { shouldValidate: true })}
                    sx={({ palette: { white, gradients }, functions: { rgba, linearGradient } }) => ({
                      border: selectedType === opt.value ? "2px solid #1A73E8" : "1px solid #ddd",
                      borderRadius: "12px",
                      padding: "16px",
                      textAlign: "center",
                      cursor: "pointer",
                      background: selectedType === opt.value ? "#F0F7FF" : linearGradient(rgba(gradients['white'].main, 1), rgba(gradients['white'].state, 1)),
                      transition: "all 0.2s ease",
                      "&:hover": { borderColor: "#1A73E8" }
                    })}
                  >
                    <input
                      type="radio"
                      {...register("formData.type")}
                      value={opt.value}
                      checked={selectedType === opt.value}
                      style={{ display: 'none' }}
                    />
                    <SoftTypography variant="button" fontWeight="bold" display="block" sx={{fontSize: '15px'}}>
                      {opt.label}
                    </SoftTypography>
                    <SoftTypography variant="caption" color="text" sx={{ fontSize: '11px' }}>
                      {opt.desc}
                    </SoftTypography>
                  </SoftBox>
                </Grid>
              ))}
            </Grid>
          </SoftBox>
          <Divider sx={{ my: 2 }} />
        </>
      )}

      {preview && (
        <SoftBox mb={1} display="flex">
          <Chip 
            label={activeOption ? activeOption.label.toUpperCase() : "GENERAL"} 
            size="big" 
            // color="dark" 
            sx={{ fontWeight: 'bold', fontSize: '14px', height: '25px' }} 
          />
        </SoftBox>
      )} */}

      {/* TITLE */}
      <SoftBox mb={preview ? 1 : 2}>
        <SoftBox pl={1} mb={0.5}>
          <SoftTypography variant={preview ? "caption" : "body3"} fontWeight="bold">Title</SoftTypography>
        </SoftBox>
        <SoftInput 
          placeholder="e.g., Line 86 Service Update" 
          {...(!preview ? register('formData.title', { required: "A Title is required" }) : { value: currentValues?.title || '', disabled: true })} 
          error={!preview && !!errors?.formData?.title}
          size={preview ? "small" : "medium"}
        />
        {!preview && <ErrorMessage error={errors?.formData?.title} />}
      </SoftBox>

      {/* DELAY FIELD: Only shows if "Delay" is active */}
      {selectedType === "service" && (
        <SoftBox mb={preview ? 1 : 2}>
          <SoftBox pl={1} mb={0.5}>
            <SoftTypography variant={preview ? "caption" : "body3"} fontWeight="bold">Service Text</SoftTypography>
          </SoftBox>
          <SoftInput 
            placeholder="e.g., 86" 
            {...(!preview ? register('formData.shortServiceText', { required: selectedType === "service" }) : { value: currentValues?.shortServiceText || '', disabled: true })} 
            error={!preview && !!errors?.formData?.shortServiceText}
            size="small"
          />
          {!preview && <ErrorMessage error={errors?.formData?.shortServiceText} />}
        </SoftBox>
      )}
      
      {/* DESCRIPTION */}
      <SoftBox mb={0}>
        <SoftBox pl={1} mb={0.5}>
          <SoftTypography variant={preview ? "caption" : "body3"} fontWeight="bold">Description</SoftTypography>
        </SoftBox>
        <SoftInput 
          placeholder="Provide more details here..." 
          multiline
          rows={preview ? 2 : 3}
          {...(!preview ? register('formData.text') : { value: currentValues?.text || '', disabled: true })} 
          error={!preview && !!errors?.formData?.text}
          size="small"
        />
        {!preview && <ErrorMessage error={errors?.formData?.text} />}
      </SoftBox>
    </SoftBox>
  );
};

export default YarraTramsForm;